import { render, staticRenderFns } from "./getBomDialog.vue?vue&type=template&id=f3971a4c"
import script from "./getBomDialog.vue?vue&type=script&lang=js"
export * from "./getBomDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports